import {
  GET_CREDENTIALSNT,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_CREDENTIALSNT,
  UPDATE_CREDENTIALSNT,
  DELETE_CREDENTIALSNT,
  GET_CREDENTIALSNT_STATES,
  GET_CREDENTIALSNT_SPECIALTIES,
} from './actionType';

const INIT_STATE = {
  credentialsNT: [],
  error: {},
  success: '',
  states: [],
  specialties: [],
  successDelete: ''
};

const CredentialsNT = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CREDENTIALSNT:
          return {
            ...state,
            credentialsNT: action.payload.data,
            success: '',
            error: {},
          };
        case CREATE_CREDENTIALSNT:
          return {
            ...state,
            success: 'Successfully created',
            error: {},
          };
        case UPDATE_CREDENTIALSNT:
          return {
            ...state,
            success: 'Successfully updated',
            error: {},
          };
        case DELETE_CREDENTIALSNT:
          return {
            ...state,
            successDelete: 'Successfully Deleted',
            error: {},
          };
        case GET_CREDENTIALSNT_STATES:
          return {
            ...state,
            states: action.payload.data,
            success: 'Successfully get states',
            error: {},
          };
        case GET_CREDENTIALSNT_SPECIALTIES:
          return {
            ...state,
            specialties: action.payload.data,
            success: 'Successfully get specialties',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_CREDENTIALSNT:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CREATE_CREDENTIALSNT:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case UPDATE_CREDENTIALSNT:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case DELETE_CREDENTIALSNT:
          return {
            ...state,
            successDelete: '',
            error: action.payload.error,
          };
        case GET_CREDENTIALSNT_STATES:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case GET_CREDENTIALSNT_SPECIALTIES:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_CREDENTIALSNT: {
      return {
        ...state,
      };
    }
    case CREATE_CREDENTIALSNT: {
      return {
        ...state,
      };
    }
    case UPDATE_CREDENTIALSNT:
      return {
        ...state,
      };
    case DELETE_CREDENTIALSNT:
      return {
        ...state,
      };
    case GET_CREDENTIALSNT_STATES: {
      return {
        ...state,
      };
    }
    case GET_CREDENTIALSNT_SPECIALTIES: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default CredentialsNT;
